import { Component, Fragment } from 'react';
import 'react-toggle/style.css';

import TaskCard from '../cards/taskCard';
import TextEditor from '../../views/pages/components/textEditor';
import moment from 'moment';

const getMeta = (url, cb) => {
    const img = new Image();
    img.onload = () => cb(null, img);
    img.onerror = (err) => cb(err);
    img.src = url;
};

class FeedbackComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedComponentTab: 'General',
            componentSelected: false,
            selectedPartialIndex: null,
            parameterSelected: false,
            parameterPath: '',
            color: {},
            displayColorPickers: {},
            // optional, reset this if you dont want to preserve selectscted component tab for nested compmonents
            selectedNestedComponentTab: {},
            customFields: this.props.customFields,
            nestedIndexSelected: -1,
            newThread: null,
            selectedThreadId: null,
            newComment: '',
            isAddingComment: false,
            toggleNewComment: false,
            toggleNewThread: false,
            editCount: 0,
            threadFilter: 'all', // 'all' or 'open'
            isCreatingThread: false,
        };

    }

    componentDidUpdate(prevProps) {
        // Reset creating thread state when newThread is cleared (indicating creation completed)
        if (prevProps.newThread && !this.props.newThread && this.state.isCreatingThread) {
            this.setState({ isCreatingThread: false });
        }
    }

    focusComponent = (partialIndex) => {

        this.props.focusComponent(partialIndex);

    };

    focusNestedComponent = (nestedIndex) => {
        this.setState({ nestedIndexSelected: nestedIndex })
    };

    unfocusComponent = () => {
        this.props.focusComponent(false, 0);
        this.props.setParameterSelected(false, '');
    };



    setToValue(obj, value, path) {
        var i;
        path = path.split('.');
        for (i = 0; i < path.length - 1; i++) obj = obj[path[i]];

        obj[path[i]] = value;
    }

    isContentValid = (html) => {
        return html && html.trim().length > 0;
    }

    handleNewThreadOnChange = (objChange) => {
        let newThread = this.state.newThread || {};
        newThread = { ...newThread, ...objChange };
        this.setState({ newThread });
    }

    addNewThread = () => {
        const { newThread } = this.state;

        // Prevent submitting empty threads
        if (!this.isContentValid(newThread?.message)) return;

        let payload = {
            message: newThread.message,
        };

        this.props.addNewThread(payload, () => {
            this.setState({ newThread: null });
        });
    }

    handleNewCommentChange = (value) => {
        this.setState({
            newComment: value,
            toggleNewComment: true
        });
    }


    addNewComment = () => {
        const { newComment, selectedThreadId } = this.state;
        const { authenticatedUser } = this.props;

        // Prevent submitting empty comments
        if (!this.isContentValid(newComment)) return;

        this.setState({ isAddingComment: true });

        // Find the current thread
        const currentThread = this.props.feedbackThreads.find(t => t._id === selectedThreadId);
        if (!currentThread) return;

        // Create new comment object
        const newCommentData = {
            message: newComment,
            author: {
            [this.props.isAdmin ? 'adminUserId' : 'sharedUserId']: authenticatedUser._id
            },
        };

        // Update thread with new comment
        const updatedThread = {
            ...currentThread,
            comments: [...(currentThread.comments || []), newCommentData]
        };

        // Use patchThread to update the entire thread
        this.props.patchThread(selectedThreadId, updatedThread, () => {
            this.setState({ newComment: '', isAddingComment: false, toggleNewComment: false, editCount: this.state.editCount + 1 });
        });
    }

    updateCommentMessage = (commentId, message, callback) => {
        const { selectedThreadId } = this.state;

        // Prevent updating to empty message
        if (!this.isContentValid(message)) return;

        // Find the current thread
        const currentThread = this.props.feedbackThreads.find(t => t._id === selectedThreadId);
        if (!currentThread) return;

        // Update the specific comment
        const updatedComments = currentThread.comments.map(comment =>
            comment._id === commentId
                ? { ...comment, message: message }
                : comment
        );

        // Update thread with edited comment
        const updatedThread = {
            ...currentThread,
            comments: updatedComments
        };

        // Use patchThread to update the entire thread
        this.props.patchThread(selectedThreadId, updatedThread, () => {
            this.setState({ editCount: this.state.editCount + 1 });
            callback && callback();
        });
    }

    deleteThread = (threadId) => {
        // Call the deleteThread method from ShareableEmailModule which handles editCount increment
        this.props.deleteThread(threadId, () => {
            // Navigate back to threads list view after successful deletion
            this.setState({ selectedThreadId: null });
        });
    }

    deleteComment = (commentId) => {
        const { selectedThreadId } = this.state;

        // Find the current thread
        const currentThread = this.props.feedbackThreads.find(t => t._id === selectedThreadId);
        if (!currentThread) return;

        // Remove the specific comment
        const updatedComments = currentThread.comments.filter(comment => comment._id !== commentId);

        // Update thread with removed comment
        const updatedThread = {
            ...currentThread,
            comments: updatedComments
        };

        // Use patchThread to update the entire thread
        this.props.patchThread(selectedThreadId, updatedThread, () => {
            this.setState({ editCount: this.state.editCount + 1 });
        });
    }

    toggleDeleteComment = (commentId) => {
        if (window.confirm('Are you sure you want to delete this message?')) {
            this.deleteComment(commentId);
        }
    }

    toggleDeleteThread = (threadId) => {
        if (window.confirm('Are you sure you want to delete this comment?')) {
            this.deleteThread(threadId);
        }
    }

    formatDate = (createdAt) => {
        const now = new Date();
        const createdDate = new Date(createdAt);
        const diffTime = Math.abs(now - createdDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));


        let formattedDate = '';

        if (now.toDateString() === createdDate.toDateString()) {
            // If posted today
            formattedDate = `${moment(createdAt).format('LT')} Today`;

        } else if (diffDays >= 1 && diffDays <= 6) {
            // If posted 1-6 days ago
            formattedDate = moment(createdAt).format('ddd h:mm a');
        } else {
            // If posted 7+ days ago
            formattedDate = `${moment(createdAt).format('MMM')} ${moment(createdAt).format('M')}/${moment(createdAt).format('YY')}`;//Dex 12/23

        }

        return formattedDate;
    }

    renderThreadDetailView = () => {
        const { selectedThreadId } = this.state;
        const thread = this.props.feedbackThreads.find(t => t._id === selectedThreadId);

        if (!thread) return null;

        return (
            <div className='h-100'>
                {/* Back Button */}
                <div className='flex-ac mb-20'>
                    <div
                        className="neu min c-pointer"
                        onClick={() => this.setState({ selectedThreadId: null })}
                    >
                        <i className="las la-angle-left mr-5"></i>Back to Comments
                    </div>
                </div>


                <div className='mb-20'>
                    {(() => {
                        const isOwner = thread.author.email === this.props.authenticatedUser.email;
                        const canModerate = isOwner || this.props.isAdmin;
                        let createdAt = thread.createdAt ? this.formatDate(thread.createdAt) : '';
                        let description = <p className='small grey'>{createdAt}</p>
                        return (
                            <TaskCard
                                id={thread._id}
                                message={thread.message}
                                author={thread.author.fullName}
                                authorAcronym={thread.counter}
                                description={description}
                                users={[]}
                                assign={() => { }}
                                assignedTo={{ firstName: '', lastName: '' }}
                                completed={thread.status === 'resolved'}
                                updateStatus={this.props.isAdmin ? (threadId, isCompleted) => {
                                    const currentThread = this.props.feedbackThreads.find(t => t._id === threadId);
                                    if (currentThread) {
                                        const updatedThread = {
                                            ...currentThread,
                                            status: isCompleted ? 'resolved' : 'open'
                                        };
                                        this.props.patchThread(threadId, updatedThread);
                                    }
                                } : () => { }}
                                updateMessage={(id, editedMessage, callback) => {
                                    this.props.patchThread(id, { message: editedMessage }, callback);
                                }}
                                settings={canModerate ? [{ label: 'Delete Comment', onClick: this.toggleDeleteThread }] : []}
                                htmlOnly={true}
                                enableEditComment={canModerate}
                                myTaskView={true}
                                disableStatus={false}
                                removeBorder={true}
                                thumbnailBackgroundColor={'var(--primary)'}

                            />
                        );
                    })()}
                </div>

                {/* Messages List */}
                <div className='mt-20'>
                    <div className='mt-20 mb-10'>
                        <h3>Messages</h3>
                    </div>

                    {thread.comments && thread.comments.length > 0 ? (
                        <div key={`comments-list-${this.state.editCount}`}>
                            {thread.comments.map((comment, cIndex) => {
                                const isOwner = comment.author?.sharedUserId === this.props.authenticatedUser._id;
                                const acronym = (comment.author?.fullName || '')
                                    .split(' ')
                                    .filter(n => n.length > 0)
                                    .map(n => n[0])
                                    .join('')
                                    .toUpperCase() || '?';
                                const canModerate = isOwner || this.props.isAdmin;
                                let createdAt = comment.createdAt ? this.formatDate(comment.createdAt) : '';
                                let description = <p className='small grey'>{createdAt}</p>
                                return (
                                    <div key={`comment-${comment._id}-${this.state.editCount}`} className="mb-15">
                                        <TaskCard
                                            id={comment._id}
                                            message={comment.message}
                                            author={comment.author?.fullName || comment.createdBy?.fullName || 'Unknown'}
                                            authorAcronym={acronym}
                                            description={description}
                                            users={[]}
                                            assign={() => { }}
                                            assignedTo={comment.assignedTo}
                                            completed={comment.completed || false}
                                            updateStatus={() => { }}
                                            updateMessage={this.updateCommentMessage}
                                            settings={canModerate ? [{ label: 'Delete Message', onClick: this.toggleDeleteComment }] : []}
                                            htmlOnly={false}
                                            enableEditComment={canModerate}
                                            myTaskView={true}
                                            customEditLabel={'Edit Message'}
                                            disableStatus={true}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="text-muted">No messages yet.</div>
                    )}

                    {/* Add Message Input */}
                    <div className='mt-20 ' >
                        <TextEditor
                            id={`newThreadComment-${selectedThreadId}`}
                            key={`editor-comment-${selectedThreadId}-${this.state.editCount}`}
                            value={this.state.newComment}
                            onChange={this.handleNewCommentChange}
                            className={`activeToolbar`}
                            options={[]}
                            placeholder={`Add a message...`}
                            staticToolbar={true}
                            hideToolbar={!this.state.toggleNewComment}
                            style={{ marginBottom: 100 }}
                        />

                        {this.state.toggleNewComment && (
                            <div className='flex fcc aic ml-a pt-10'
                                style={{
                                    flexFlow: 'row-reverse',
                                }}
                            >
                                <button
                                    className={`${this.state.isAddingComment || !this.isContentValid(this.state.newComment)? 'disabled' : 'prim min '}`}
                                    onClick={() => {
                                        // Validate content before submitting
                                        if (!this.isContentValid(this.state.newComment)) return;

                                        this.setState({ isAddingComment: true });
                                        this.addNewComment();
                                    }}
                                    disabled={this.state.isAddingComment || !this.isContentValid(this.state.newComment)}
                                >
                                    Add Message
                                </button>
                                <button
                                    className='neu mr-25 min'
                                    onClick={() => this.setState({ newComment: '', toggleNewComment: false, editCount: this.state.editCount + 1 })}
                                    disabled={this.state.isAddingComment}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        );
    };

    renderThreadsListView = () => {
        return (
            <div className='h-100'>
                {/* New Thread Input */}
                {this.props.newThread && (
                    <div className='mb-20'>
                        <TextEditor
                            id={`newThread`}
                            key={`editor-thread-${this.state.editCount}`}
                            value={''}
                            onChange={(value) => {
                                this.props.handleNewThreadOnChange({ message: value });
                                this.setState({ toggleNewThread: true });
                            }}
                            className={`activeToolbar`}
                            options={[]}
                            placeholder={`Add a new comment...`}
                            staticToolbar={true}
                            handleFocus={() => {

                            }}
                            hideToolbar={!this.state.toggleNewThread}
                        />
                        {this.state.toggleNewThread && (
                            <div className='flex fcc aic ml-a pt-10 '
                                style={{
                                    flexFlow: 'row-reverse',
                                }}
                            >
                                <button className={`${this.state.isCreatingThread || !this.isContentValid(this.props.newThread?.message) ? 'disabled' : 'prim min '}`}
                                    onClick={() => {
                                        // Validate content before submitting
                                        if (!this.isContentValid(this.props.newThread?.message)) return;

                                        this.setState({ isCreatingThread: true });
                                        this.props.createNewThread();
                                    }}
                                    disabled={this.state.isCreatingThread || !this.isContentValid(this.props.newThread?.message)}
                                >
                                    {this.state.isCreatingThread ? 'Adding...' : 'Add Comment'}
                                </button>
                                <button className='neu mr-25 min'
                                    onClick={() => this.setState({ toggleNewThread: false, editCount: this.state.editCount + 1 })}>
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                )}

                {/* Comments Header with Filter Toggle */}
                <div className=' mb-10'>
                    <div className='flex aic jcsb'>
                        <h3>Comments</h3>
                        <div className='flex aic' style={{ gap: '8px' }}>
                            <button
                                className={`min ${this.state.threadFilter === 'all' ? 'prim' : 'neu'}`}
                                onClick={() => this.setState({ threadFilter: 'all' })}
                                style={{
                                    padding: '6px 12px',
                                    fontSize: '12px',
                                    borderRadius: '4px',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                All
                            </button>
                            <button
                                className={`min ${this.state.threadFilter === 'open' ? 'prim' : 'neu'}`}
                                onClick={() => this.setState({ threadFilter: 'open' })}
                                style={{
                                    padding: '6px 12px',
                                    fontSize: '12px',
                                    borderRadius: '4px',
                                    border: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                Open
                            </button>
                        </div>
                    </div>
                </div>

                {/* Comments List */}
                {(() => {
                    const filteredThreads = this.props.feedbackThreads.filter(thread => {
                        if (thread.deleted) return false;
                        if (this.state.threadFilter === 'open') {
                            return !thread.status || thread.status === 'open';
                        }
                        return true;
                    });
                    return (
                        <>
                            {filteredThreads.length === 0 && (
                                <div className='text-muted'>
                                    {this.state.threadFilter === 'open'
                                        ? 'No open comments.'
                                        : 'No comments have been added yet.'
                                    }
                                </div>
                            )}

                            <div key={`threads-list-${this.state.editCount}`}>
                                {filteredThreads.map((thread, index) => {
                                    const isOwner = thread.author?.sharedUserId === this.props.authenticatedUser._id;
                                    const canModerate = isOwner || this.props.isAdmin;
                                    let createdAt = thread.createdAt ? this.formatDate(thread.createdAt) : '';
                                    let description = <p className='small grey'>{createdAt}</p>
                                    return (
                                        <div key={`thread-${thread._id}-${this.state.editCount}`} className="mb-15 ">
                                            <TaskCard
                                                id={thread._id}
                                                message={thread.message}
                                                author={thread.author.fullName}
                                                authorAcronym={thread.counter}
                                                description={description}
                                                users={[]}
                                                assign={() => { }}
                                                assignedTo={{ firstName: '', lastName: '' }}
                                                completed={thread.status === 'resolved'}
                                                updateStatus={this.props.isAdmin ? (threadId, isCompleted) => {
                                                    const currentThread = this.props.feedbackThreads.find(t => t._id === threadId);
                                                    if (currentThread) {
                                                        const updatedThread = {
                                                            ...currentThread,
                                                            status: isCompleted ? 'resolved' : 'open'
                                                        };
                                                        this.props.patchThread(threadId, updatedThread);
                                                    }
                                                } : () => { }}
                                                updateMessage={(id, editedMessage, callback) => {
                                                    this.props.patchThread(id, { message: editedMessage }, callback);
                                                }}
                                                settings={canModerate ? [{ label: 'Delete Comment', onClick: this.toggleDeleteThread }] : []}
                                                htmlOnly={false}
                                                enableEditComment={true}
                                                myTaskView={true}
                                                disableStatus={false}
                                                onTileClick={() => this.setState({ selectedThreadId: thread._id })}
                                                thumbnailBackgroundColor={'var(--primary)'}
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    );
                })()}
            </div>
        );
    };

    selectThread = (threadId) => {
        this.setState({ selectedThreadId: threadId });
    }

    render() {
        const { selectedThreadId } = this.state;

        return (
            <Fragment>
                <div className='h-100'>
                    {selectedThreadId ? this.renderThreadDetailView() : this.renderThreadsListView()}
                </div>
            </Fragment>
        );
    }
}

export default FeedbackComponent;
